/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ApiService, AuthStoreService } from '../../../../core/services';
import { DataServicesEnum } from '../enums/api';
import { ErrorResponseModel } from '../../../../core/models';
import { Injectable } from '@angular/core';
import { ModulesEnum } from '../../../../core/enums';
import { Observable } from 'rxjs';

@Injectable()
export class DataServicesApiService {
    constructor(
        private api: ApiService,
        private authStoreService: AuthStoreService
    ) {
    }

    /**
     * Get all data services
     * @returns {Observable<any>}
     */
    public getDataServices(options?: any) {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

            this.api.get(
                DataServicesEnum.GET_DATA_SERVICES,
                moduleAuth,
                true
            ).subscribe(
                (response: unknown) => {
                    // inform our watchers
                    observer.next(response);
                    observer.complete();
                },
                (error: ErrorResponseModel) => {
                    observer.next(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * Get data service details by name.
     * @param name
     * @param options
     */
    public getDataServicesByName(name: string, options?: any): Observable<any> {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

            this.api.get(
                DataServicesEnum.GET_DATA_SERVICES_BY_NAME(name),
                moduleAuth, true
            ).subscribe(
                (response: any) => {
                    observer.next(response);
                    observer.complete();
                },
                (error: ErrorResponseModel) => {
                    observer.next(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * Update the data collectors.
     * @param name
     * @param data
     * @param options
     */
    public updateDataServiceByName(name: string, data: any, options?: any): Observable<any> {
        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);

            this.api.put(
                DataServicesEnum.PUT_DATA_SERVICES_NAME(name),
                { 'data': data },
                moduleAuth,
                true
            ).subscribe(
                (response: any) => {
                    // inform our watchers
                    observer.next(response);
                    observer.complete();
                },
                (error: ErrorResponseModel) => {
                    observer.next(error);
                    observer.complete();
                }
            );
        });
    }
}
